import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

export const Container = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 960px;
  padding: 15px 30px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    height: fit-content;
    padding: 0 0 20px;
  }
`;

export const SuccessAlert = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background-color: ${colours.mint[300]};
  border-radius: 15px;
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  > h1 {
    flex: 1;
    min-width: 0;

    @media (max-width: ${breakpoints.tablet}) {
      font-size: clamp(28px, 8vw, 48px);
      line-height: 1.1;
    }
  }
`;

export const Avatar = styled('div')`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${colours.neutral[200]};
  border: 1px solid rgba(0, 0, 0, 0.05);
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DetailsSection = styled('div')`
  border-radius: 20px;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 15px;
`;

export const DetailRow = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Divider = styled('div')`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  flex: 1;
`;

export const EventsSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
  position: relative;
`;

export const EventsHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const EventsList = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  padding-bottom: 30px;
  position: relative;
`;
